
import { t } from "@/plugins/i18n";
export default interface DisplayStatus {
  name: string;
  readOnly: boolean;
  deleted: boolean;
  id: number;
}

export const displayStatusDefaultProps: DisplayStatus = {
  name: t("Osszes"),
  readOnly: true,
  deleted: false,
  id: 1,
};
